import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { PROJECT_VIEWS, ProjectPage, type ProjectView } from "@/features/work/ProjectPage";

const search = z.object({ peek: z.string().optional(), assignee: z.string().optional() });

export const Route = createFileRoute("/_app/projects/$project/$tab")({
  validateSearch: search,
  beforeLoad: ({ params }) => {
    if (params.tab === "tasks") throw redirect({ to: "/projects/$project/$tab", params: { ...params, tab: "list" }, search: (s: Record<string, unknown>) => s });
  },
  component: Page,
});

function Page() {
  const { project, tab } = Route.useParams();
  const { peek, assignee } = Route.useSearch();
  const view: ProjectView = (PROJECT_VIEWS as readonly string[]).includes(tab) ? (tab as ProjectView) : "list";
  return <ProjectPage slug={project} view={view} peek={peek} assignee={assignee} />;
}
